<script lang="ts">
	import { getContext } from "svelte";
	import IMask from "imask";
	import Input from "$form/Fields/Shared/Input.svelte";
	import FieldError from "$form/Fields/Shared/FieldError.svelte";
	import Label from "$form/Fields/Shared/Label.svelte";
	import Description from "$form/Fields/Shared/Description.svelte";
	import { createEventDispatcher, onMount } from "svelte";
	import { imask_definitions } from "$lib/helpers/validate";

	const styling = getContext<Styling>("styling");

	export let field: FieldDisplay & { type: "OneLineInput" };
	export let value: string;

	let inputRef: HTMLInputElement;
	let mask: any;
	let inputmode:
		| "email"
		| "tel"
		| "text"
		| "numeric"
		| "decimal"
		| "url"
		| "search" = "text";
	$: {
		if (field.settings.validation === "url") {
			inputmode = "url";
		} else if (field.settings.validation === "digits") {
			inputmode = "numeric";
		} else if (field.settings.validation === "numeric") {
			inputmode = "decimal";
		} else {
			inputmode = "text";
		}
	}
	const dispatch = createEventDispatcher();

	onMount(() => {
		inputRef.addEventListener("focus", () => {
			dispatch("updateOther", {
				active: true
			});
		});
		inputRef.addEventListener("blur", () => {
			dispatch("updateOther", {
				tainted: true
			});
			dispatch("updateOther", {
				active: false
			});
		});
		if (field.settings.validation === "pattern" && field.settings.pattern) {
			mask = IMask(inputRef, {
				mask: field.settings.pattern,
				definitions: imask_definitions,
				lazy: false
			});
			mask.on("accept", () => {
				if (value !== mask._value) {
					value = mask._value;
				}
			});
		}
	});
</script>

<div
	class="field-label-cover"
	class:has-placeholder="{styling.placeholders !== false}">
	{#if field.labelHTMLComputed && field.settings.hideLabel !== true}
		{#if styling.placeholders === false}
			<Label html="{field.labelHTMLComputed}" />
		{/if}
		{#if field.descriptionHTMLComputed}
			<Description html="{field.descriptionHTMLComputed}" />
		{/if}
	{/if}
</div>
<div class="field-input-cover">
	<Input
		type="text"
		bind:element="{inputRef}"
		value="{value}"
		prefixIcon="{field.styling?.prefixIcon}"
		prefixText="{field.styling?.prefixText}"
		suffixIcon="{field.styling?.suffixIcon}"
		suffixText="{field.styling?.suffixText}"
		on:input="{() => {
			if (!mask) {
				value = inputRef.value;
			}
		}}"
		inputmode="{inputmode}"
		name="{field.id}"
		placeholder="{styling.placeholders
			? field.labelComputed
			: (field.styling?.placeholder ?? '')}"
		label="{field.labelComputed}" />
	<FieldError
		visible="{field.tainted}"
		valid="{field.valid}"
		errorNumber="{field.errorNumber}"
		errorType="{field.errorType}" />
</div>
